module.exports = __webpack_public_path__ + "img/countdowns.4cec60da.svg";